import React from 'react';
import cn from 'classnames';
import { LABEL } from '../../../veriables';
import { flowType } from '@utility/userInfo';
import { APP_CONFIG } from '@constants';
import style from '../../PaymentScreens/paymentScreens.module.scss';
import { TouchableButton } from '../../common/Touchable/index';
import { getObjectValue } from "@utility/utills";

const StartScreen = ({ PaymentPageBtn, serverAppTheme, onClearSplit, ...props}) => {
    const buttonControl = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('seat'))?.control, {});
    const payAnAmountBtn = PaymentPageBtn.find((btn) => { return btn?.name === 'Pay Full Check' });
    const handleRouteBack = () => {
        props.navigate(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`, { replace: true });
    }

    return (
        <div className={cn("col-12 h-91 row mx-0 pr-0 py-2 align-items-center justify-content-center pl-2 mt-4 pt-3")}>
            {buttonControl?.enableOtherPaymentOptions &&
                <div
                    className={cn('col-12 p-0')}
                >
                    <TouchableButton
                        style={{ height: '3.9375rem', fontSize: '1.35rem', fontWeight: 600, background: !buttonControl?.enableOtherPaymentOptions ? serverAppTheme?.secondaryBtnDisabled : serverAppTheme?.secondaryBtn, color: !buttonControl?.enableOtherPaymentOptions ? serverAppTheme?.btn_font_color_disabled : serverAppTheme?.btn_font_color }}
                        className={cn('col-12 btn my-1 px-0 btn-ripple fw-600')}
                        disabled={!buttonControl?.enableOtherPaymentOptions}
                    >
                        {LABEL().OTHER_PAYMENT_OPTIONS}
                    </TouchableButton>
                </div>
            }
            <div
                className={cn('col-12 p-0')}
            >
                <TouchableButton
                    style={{ height: '3.9375rem', fontSize: '1.35rem', fontWeight: 600, background: serverAppTheme?.secondaryBtn, color: serverAppTheme?.btn_font_color }}
                    className={cn('col-12 btn44 my-1 px-0 btn-ripple fw-600')}
                    onClick={() => {handleRouteBack()}}
                    rippleEffect={true}
                >
                    {LABEL().LS_BACK}
                </TouchableButton>
                <TouchableButton
                    style={{ height: '3.9375rem', fontSize: '1.35rem', fontWeight: 600, background: !buttonControl?.enableClearSplits ? serverAppTheme?.secondaryBtnDisabled : serverAppTheme?.secondaryBtn, color: !buttonControl?.enableClearSplits ? serverAppTheme?.btn_font_color_disabled : serverAppTheme?.btn_font_color }}
                    className={cn('col-12 btn44 my-1 px-1 btn-ripple fw-600',
                    )}
                    onClick={() => onClearSplit()}
                    disabled={!buttonControl?.enableClearSplits}
                    rippleEffect={true}
                >
                    {LABEL().LS_CLEAR_SPLITS}
                </TouchableButton>
            </div>
            <div className={cn('row px-0 col-12 flex-row')}>
                <div className={cn('col-12 px-0 row mx-0')}>
                    {PaymentPageBtn
                        && PaymentPageBtn.map((item, index) => {
                            return (
                                item && item.name !== 'Pay Full Check' && (
                                    <TouchableButton
                                        key={item.name}
                                        type="button"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (!item.disabled) {
                                                item.click();
                                            }
                                        }}
                                        style={{ height: '3.9375rem', background: item.disabled ? serverAppTheme?.secondaryBtnDisabled : serverAppTheme?.secondaryBtn, color: item.disabled ? serverAppTheme?.btn_font_color_disabled : serverAppTheme?.btn_font_color }}
                                        className={cn(
                                            'col-12 my-1 btn44 btn-ripple fw-600 px-0',
                                        )}
                                        disabled={item?.disabled}
                                        rippleEffect={true}
                                    >
                                        <div
                                            className={cn(style.divForPayment)}
                                            style={{ fontSize: '1.35rem', fontWeight: 600 }}
                                        >
                                            {item.name}
                                        </div>
                                    </TouchableButton>
                                )
                            );
                        })
                    }
                </div>
            </div>
            {payAnAmountBtn !== undefined &&
                <div className='col-12 w-100 px-0'>
                    <TouchableButton
                        key={payAnAmountBtn.name}
                        type="button"
                        onClick={(e) => {
                            e.preventDefault();
                            payAnAmountBtn.click();
                        }}
                        style={{ height: '3.9375rem', fontWeight: 600, background: payAnAmountBtn.disabled ? serverAppTheme?.secondaryBtnDisabled : serverAppTheme?.secondaryBtn, color: payAnAmountBtn.disabled ? serverAppTheme?.btn_font_color_disabled : serverAppTheme?.btn_font_color }}
                        className={cn(
                            'col-12 btn my-1 px-1 btn-ripple',
                        )}
                        disabled={payAnAmountBtn.disabled}
                    >
                        <div
                            className={cn('fs-18 fw-600', style.divForPayment)}
                            style={{
                                fontSize: '1.35rem',
                            }}
                        >
                            {payAnAmountBtn.name}
                        </div>
                    </TouchableButton>
                </div>
            }
        </div>
    );
};

export default StartScreen;